import React, { useState } from 'react';
import * as S from './style';
import { Btn } from 'components';

import { ReactComponent as Error } from 'assets/img/common/ic_error.svg';
import { ReactComponent as Close } from 'assets/img/common/ic_close.svg';

export interface Props {
  children: React.ReactNode | string;
  isError?: boolean;
}

function Banner({ children, isError, ...props }: Props): React.ReactElement {
  const [show, setShow] = useState<boolean>(true);

  return (
    <S.Banner show={show} error={isError} {...props}>
      <S.BackgroundLayer error={isError}>
        <S.ContentWrpper>
          <S.MessageWrpper>
            <S.ErrorIconWrapper>
              <Error />
            </S.ErrorIconWrapper>
            {children}
          </S.MessageWrpper>
          <S.CloseWrapper>
            <Btn
              onClick={() => show && setShow(false)}
              backGroundColor={'transparent'}
            >
              <Close />
            </Btn>
          </S.CloseWrapper>
        </S.ContentWrpper>
      </S.BackgroundLayer>
    </S.Banner>
  );
}
export default Banner;
